import React from 'react';
import LinearCarousel from '../Carousel';
import Building1 from '../../assets/environment/main-area.png';
import Building2 from '../../assets/environment/kitchen.png';
import Building3 from '../../assets/environment/living-area.png';
import Building4 from '../../assets/environment/rest-room.png';
import Building5 from '../../assets/environment/security-building.png';
import Building6 from '../../assets/environment/employee-house.png';

const Building = ({ id }) => {
  const BuildingImages = [
    Building1,
    Building2,
    Building3,
    Building4,
    Building5,
    Building6,
  ];

  return (
    <section className='w-full lg:w-[95%] mx-auto my-6 mt-8 px-4 lg:px-0' id={id}>
      <h1 className='text-[35px] lg:text-[45px] text-center section-header font-[700] text-[#102343] mb-6'>
      Our Buildings
      </h1>
      <LinearCarousel images={BuildingImages} style={'h-[150px]'}/>
    </section>
  );
};

export default Building;